import { defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { typography } from '@statsbomb/kitbag-themes';

var RADIO_SIZES = {
  REGULAR: 'regular',
  SMALL: 'small'
};
var RADIO_DIMENSIONS = _defineProperty(_defineProperty({}, RADIO_SIZES.SMALL, "\n    min-width: 1rem;\n    min-height: 1rem;\n    width: 1rem;\n    height: 1rem;\n  "), RADIO_SIZES.REGULAR, "\n    min-width: 1.5rem;\n    min-height: 1.5rem;\n    width: 1.5rem;\n    height: 1.5rem;\n  ");
var DOT_DIMENSIONS = _defineProperty(_defineProperty({}, RADIO_SIZES.SMALL, "\n    width: 0.25rem;\n    height: 0.25rem;\n  "), RADIO_SIZES.REGULAR, "\n    width: 0.5rem;\n    height: 0.5rem;\n  ");
var RADIO_TITLE_TYPOGRAPHY = _defineProperty(_defineProperty({}, RADIO_SIZES.SMALL, typography.headingSmall), RADIO_SIZES.REGULAR, typography.headingMedium);
var RADIO_LABEL_TYPOGRAPHY = _defineProperty(_defineProperty({}, RADIO_SIZES.SMALL, typography.bodyMedium), RADIO_SIZES.REGULAR, typography.bodyRegular);

export { DOT_DIMENSIONS, RADIO_DIMENSIONS, RADIO_LABEL_TYPOGRAPHY, RADIO_SIZES, RADIO_TITLE_TYPOGRAPHY };
//# sourceMappingURL=RadioButton.constants.js.map
